import axios from "axios";
import camelize from "camelize";
import router from "@/router";

const http = axios.create({
  baseURL: process.env.VUE_APP_MAIN_ADMIN_API,
  headers: {
    Authorization: null
  },
  withCredentials: false,
  transformResponse: [
    function(data) {
      return camelize(JSON.parse(data));
    }
  ]
});

http.interceptors.request.use(
  config => {
    const token = getCurrentToken();
    if (token) {
      config.headers["Authorization"] = token;
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// Add a response interceptor
http.interceptors.response.use(
  function(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // eslint-disable-next-line no-console
    // console.log("response", response);
    return response.data;
  },
  function(error) {
    // eslint-disable-next-line no-console
    if (error?.response?.status == 401) {
      window.localStorage.removeItem("auth.currentUser");
      if (router.currentRoute.name != "loginPage") {
        router.push({
          name: "loginPage",
          query: { reditect: router.currentRoute }
        });
      }
      return Promise.reject(error);
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);
function getCurrentToken() {
  try {
    return (
      JSON.parse(window.localStorage.getItem("auth.currentUser"))?.token || null
    );
  } catch (e) {
    return null;
  }
}

export default http;
